<!-- discover-mobile-01 preview — Google Discover feed ad -->
<app-mobile-frame>
  <app-discover-mobile-header frameTop></app-discover-mobile-header>

  <!-- START: Discover feed -->
  <div class="gd-feed">
    <!-- START: Real ad -->
    <div class="gd-card">
      <div class="gd-advertiser d-flex flex-row align-items-center gap-2">
        <img *ngIf="data.logo" class="gd-advertiser-logo" [src]="data.logo" alt="" />
        <span *ngIf="!data.logo" class="gd-advertiser-logo logo-empty" aria-hidden="true"></span>
        <div class="gd-advertiser-text">
          <div class="gd-advertiser-name">Valamar</div>
          <div class="gd-sponsored">Sponsored</div>
        </div>
      </div>

      <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="gd-creative-link">
        <img *ngIf="creativeImage" class="gd-creative-image" [src]="creativeImage" alt="" />
        <div *ngIf="!creativeImage" class="gd-creative-image creative-missing">{{ missingDimensionLabel }}</div>
      </a>

      <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="gd-text">
        {{ data.headlines[0] || "Your headline appears here" }}
        {{ data.descriptions[0] || "Your description appears here" }}
      </a>

      <div
        class="gd-actions d-flex flex-row align-items-center justify-content-end"
      >
        <i class="bi bi-heart"></i>
        <i class="bi bi-box-arrow-up"></i>
        <i class="bi bi-three-dots-vertical"></i>
      </div>
    </div>
    <!-- END: Real ad -->
  </div>
  <!-- END: Discover feed -->
</app-mobile-frame>
